import { render, staticRenderFns } from "./HelloBlock.vue?vue&type=template&id=12277dc6&lang=pug&"
import script from "./HelloBlock.vue?vue&type=script&lang=ts&"
export * from "./HelloBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports